<app-social-ai-platforms-table></app-social-ai-platforms-table>
